import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate {
  constructor(
    public navCtrl: NavController,
    private fireAuth: AngularFireAuth,
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // const claimType: string = next.data["claimType"];

    return this.fireAuth.authState.pipe(
      take(1),
      switchMap(async (authState) => {

        // check if user is logged in

        // not logged in? navigate to login page
        if (!authState) {
          console.log('access denied');
          this.navCtrl.navigateRoot('/');
          return false;
        }

        // here user is logged in
        return true;

      }),
    )
  }
}
